export function isBlank(value: string): boolean {
  return value.trim() === '';
}

export function headerIndex(headers: readonly string[], name: string): number {
  return headers.indexOf(name);
}

export function cellAt(row: readonly string[], index: number): string {
  if (index < 0 || index >= row.length) return '';
  const value = row[index];
  return value === undefined ? '' : value.trim();
}
